'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_ImportRecipesPage$State(account, currentStepNumber, urlQueue, urlDone, recipeParsingResults, urlInput, textInput, msgState, currentUrl, activeTab) {
  this.kL = null;
  this.oI = null;
  this.kN = null;
  this.kM = null;
  this.my = null;
  this.oJ = null;
  this.jd = null;
  this.mx = null;
  this.mw = null;
  this.im = 0;
  this.kL = account;
  this.oI = currentStepNumber;
  this.kN = urlQueue;
  this.kM = urlDone;
  this.my = recipeParsingResults;
  this.oJ = urlInput;
  this.jd = textInput;
  this.mx = msgState;
  this.mw = currentUrl;
  this.im = activeTab;
}
export { $c_Lmealorama_pages_ImportRecipesPage$State as $c_Lmealorama_pages_ImportRecipesPage$State };
$p = $c_Lmealorama_pages_ImportRecipesPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_ImportRecipesPage$State;
/** @constructor */
function $h_Lmealorama_pages_ImportRecipesPage$State() {
}
export { $h_Lmealorama_pages_ImportRecipesPage$State as $h_Lmealorama_pages_ImportRecipesPage$State };
$h_Lmealorama_pages_ImportRecipesPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kL));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oI));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kN));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kM));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.my));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oJ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.jd));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mx));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mw));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.im);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 10);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_ImportRecipesPage$State)) {
    if ((this.im === x$0.im)) {
      var x = this.kL;
      var x$2 = x$0.kL;
      var $x_6 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.oI;
      var x$4 = x$0.oI;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.kN;
      var x$6 = x$0.kN;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.kM;
      var x$8 = x$0.kM;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.my;
      var x$10 = x$0.my;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_2 = false;
    }
    if ((($x_2 && (this.oJ === x$0.oJ)) && (this.jd === x$0.jd))) {
      var x$11 = this.mx;
      var x$12 = x$0.mx;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.mw;
      var x$14 = x$0.mw;
      return ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 10;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.kL;
      break;
    }
    case 1: {
      return this.oI;
      break;
    }
    case 2: {
      return this.kN;
      break;
    }
    case 3: {
      return this.kM;
      break;
    }
    case 4: {
      return this.my;
      break;
    }
    case 5: {
      return this.oJ;
      break;
    }
    case 6: {
      return this.jd;
      break;
    }
    case 7: {
      return this.mx;
      break;
    }
    case 8: {
      return this.mw;
      break;
    }
    case 9: {
      return this.im;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_ImportRecipesPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ks)));
}
export { $isArrayOf_Lmealorama_pages_ImportRecipesPage$State as $isArrayOf_Lmealorama_pages_ImportRecipesPage$State };
var $d_Lmealorama_pages_ImportRecipesPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_ImportRecipesPage$State, "mealorama.pages.ImportRecipesPage$State", ({
  ks: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_ImportRecipesPage$State as $d_Lmealorama_pages_ImportRecipesPage$State };
//# sourceMappingURL=mealorama.pages.-Import-Recipes-Page$-State.js.map
